<script>
import ApiClient from '../utils/ApiClient'

export default {
  data () {
    return {
      users: []
    }
  },
  /**
   * 条件から楽曲を検索する
   * @param params formData
   **/
  searchTrue: function (params, callback, errorHandler) {
    var targetPath = 'ajax/products.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('searchTrue failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * プレイリストタイプからおすすめプレイリスト一覧を取得する
   * TODO recommended用サービスに追加
   **/
  findRecommendPlayListSet: function (typeId, transactionId, callback, errorHandler) {
    var targetPath = 'ajax/playlist_recommend_list.php' + '?transactionid=' + transactionId
    var param = '&playlist_type=' + typeId
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('findRecommendPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * プレイリストタイプからおすすめプレイリストを取得する
   * TODO recommended用サービスに追加
   **/
  findRecommendPlayList: function (playlistId, transactionId, callback, errorHandler) {
    var targetPath = 'ajax/playlist_recommend_detail.php' + '?transactionid=' + transactionId
    var param = '&playlist_id=' + playlistId
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('findRecommendPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * プレイリストを登録する
   * @param params formData
   **/
  createPlayList: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_recommend_to_customer.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('createPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
  * 進行プレイリストに適用
  **/
  applyRecommendPlayList: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_recommend_to_customer.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('addPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/PlayListService.vue